import { proxy } from 'valtio';

import type { ProjectDesign } from 'models';

const state = proxy<{
    projectDesign: ProjectDesign | null;
}>({
    projectDesign: null,
});

export { state };
